import {connect} from 'react-redux'

import {QuickTools} from './quicktools.component'
// import { deleteLeg } from '../leg/leg.action'
import {chatSend} from '../chat/chat.action'
import userUtil from '../util/user.util'


const mapStateToProps = (state) => {
    return {
        currentUser: userUtil.getCurrentUser(state)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    // onDeleteLeg: (leg) => {
    //   dispatch(deleteLeg(leg))
    // },
        onChatSend: (trip_id, message, sender_user_id, hashtag, mentions, created_at) => {
            dispatch(chatSend(trip_id, message, sender_user_id, hashtag, mentions, created_at))
        }
    }
}

const QuickToolsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(QuickTools)

export default QuickToolsContainer
